<div class="top-menu" class="topMenu">

    <a mat-button [matMenuTriggerFor]="accountMenu" #accountMenuTrigger="matMenuTrigger" *ngIf="isUserAuthenticated"
        style="color:black;border-top: 1px solid #000!important;">
        <mat-icon class="mat-icon-sm account-icon">person</mat-icon>
        <span fxShow="false" fxShow.gt-sm>{{ 'ACCOUNT' | translate }}</span>
        <mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
    </a>
    <mat-menu #accountMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown account">
        <span (mouseleave)="accountMenuTrigger.closeMenu()" *ngIf="isUserAuthenticated">
            <div fxLayout="row" fxLayoutAlign="space-around center" class="user-info">
                <img src="assets/images/others/user.jpg" alt="user-image" width="50"><br>
                <p *ngIf='isUserAuthenticated'>{{userInfo.firstName}} {{userInfo.lastName}}<br>
                    <!--   <small><span
                            *ngIf="settings.rtl">&rlm;</span>(152<mat-icon class="mat-icon-xs">star</mat-icon>)</small> -->
                </p>
            </div>
            <div class="divider"></div>
            <a mat-menu-item routerLink="/account">
                <mat-icon class="mat-icon-sm">settings</mat-icon>
                <span>Account Settings</span>
            </a>

            <div class="divider"></div>
            <a mat-menu-item *ngIf='!isUserAuthenticated'>
                <mat-icon class="mat-icon-sm">power_settings_new</mat-icon>
                <span>{{ 'LOGOUT' | translate }}</span>
            </a>
            <a mat-menu-item *ngIf='isUserAuthenticated' (click)="logout()">
                <button class="mat-button" style="color: #f5080880;" (click)="logout()">Logout</button>
            </a>
        </span>
    </mat-menu>

</div>